if (!customElements.get('expandable-description')) {
  customElements.define(
    'expandable-description',
    class ExpandableDescription extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.content = this.querySelector('[data-description-content]');
        this.toggle = this.querySelector('[data-description-toggle]');

        if (!this.details || !this.content || !this.toggle) return;

        this.updateCollapsible();
        this.details.addEventListener('toggle', () => this.syncExpandedState());

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateCollapsible());
          this.resizeObserver.observe(this.content);
        }
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      updateCollapsible() {
        if (this.details.open) {
          this.toggle.hidden = false;
          this.syncExpandedState();
          return;
        }

        this.classList.add('is-collapsible');
        const overflows = this.content.scrollHeight > this.content.clientHeight + 8;
        this.classList.toggle('is-collapsible', overflows);
        this.toggle.hidden = !overflows;
        this.syncExpandedState();
      }

      syncExpandedState() {
        const expanded = this.details.open;
        this.toggle.setAttribute('aria-expanded', String(expanded));
        this.content.toggleAttribute('inert', this.classList.contains('is-collapsible') && !expanded);
      }
    }
  );
}
